import { queryKeyFn } from '@sit/client-shared';
import { queryClient } from '@web/hooks/api/query/client';
import { put } from 'redux-saga/effects';
import { track } from '../../analytics/analyticsClient';
import trackEvents from '../../analytics/trackEvents';
import api from '../../helpers/api';
import toastr from '../../helpers/toastr';
import * as timesheetEntriesActions from '../TimesheetEntries/actions';
import * as timesheetRowsActions from '../TimesheetRows/actions';
import { selectToken } from '../selectors';
import { store } from '../store';
import * as actions from './actions';

const invalidateTimesheets = () => {
  return queryClient.invalidateQueries([
    queryKeyFn({
      path: '/timesheets',
      operationId: 'getApiTimesheets',
      variables: {},
    }),
  ]);
};

export function* getTimesheetRequestSaga(payload) {
  try {
    const res = yield api.send({
      url: `/timesheets/${payload.data.id}`,
      method: 'GET',
      token: selectToken(store.getState()),
    });
    yield put(actions.getTimesheetRequestSuccess(res));
  } catch (error) {
    yield put(actions.getTimesheetRequestFailure(error));
  }
}

export function* saveTimesheetRequestAsyncSaga(payload) {
  try {
    const res = yield api.send({
      url: `/timesheets/${payload.data.id}/save-async`,
      method: 'POST',
      token: selectToken(store.getState()),
    });
    yield put(actions.saveTimesheetRequestSuccess(res));
    yield put(actions.getTimesheetRequest({ id: payload.data.id }));
    toastr.info(`Syncing your timesheet, we'll notify you when we finish.`, { toastId: payload.data.id });
  } catch (error) {
    yield put(actions.saveTimesheetRequestFailure(error));
  }
}

export function* saveTimesheetRequestAsyncSagaFailure(payload) {
  const timesheetId = payload.error?.id;
  yield put(timesheetRowsActions.getTimesheetRowsRequest({ timesheetId }));
  yield put(timesheetEntriesActions.getTimesheetEntriesRequest({ timesheetId, showToast: true }));
}

export function* saveTimesheetRequestAsyncSagaSuccess(payload) {
  yield put(timesheetRowsActions.getTimesheetRowsRequest({ timesheetId: payload.data.id }));
  yield put(timesheetEntriesActions.getTimesheetEntriesRequest({ timesheetId: payload.data.id, showToast: true }));
  yield put(actions.updateSyncStatus(true));
  track(trackEvents.TIMESHEET_SAVE);
}

export function* submitTimesheetRequestSagaAsyncFailure(payload) {
  const timesheetId = payload.error?.id;
  yield put(timesheetRowsActions.getTimesheetRowsRequest({ timesheetId }));
  yield invalidateTimesheets();
  yield put(timesheetEntriesActions.getTimesheetEntriesRequest({ timesheetId, showToast: true }));
  if (payload.error?.refetchTimesheet) yield put(actions.getTimesheetRequest({ id: timesheetId }));
}

export function* submitTimesheetRequestSagaAsyncSuccess(payload) {
  yield put(actions.updateSyncStatus(true));
  yield put(timesheetRowsActions.getTimesheetRowsRequest({ timesheetId: payload.data.id }));
  yield invalidateTimesheets();
  yield put(timesheetEntriesActions.getTimesheetEntriesRequest({ timesheetId: payload.data.id, showToast: true }));
  if (payload.data.refetchTimesheet) yield put(actions.getTimesheetRequest({ id: payload.data.id }));
  track(trackEvents.TIMESHEET_SUBMIT);
}
